import {lerpGreenToRedViaOrange} from "./scaling";
import {scaleNumber} from "../lq_js_common/helpers/scaling";

export const TRAFFIC_OVERVIEW_NO_DATA_COLOR = "#6c757d";
export const TRAFFIC_OVERVIEW_SHAPER_COLOR = "#9b59b6";
const RTT_STATUS_MAX_MS = 200;

function finiteNumber(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

export function shaperChildrenRttToMs(rawValue) {
    const value = finiteNumber(rawValue);
    return value === null ? null : value / 10;
}

export function asnRttToMs(rawValue) {
    const value = finiteNumber(rawValue);
    return value === null ? null : value / 100;
}

export function colorForMedianRtt(rttMs) {
    if (!Number.isFinite(rttMs)) {
        return TRAFFIC_OVERVIEW_NO_DATA_COLOR;
    }
    const clamped = Math.min(RTT_STATUS_MAX_MS, Math.max(0, rttMs));
    return lerpGreenToRedViaOrange(RTT_STATUS_MAX_MS - clamped, RTT_STATUS_MAX_MS);
}

export function medianRttStatusLabel(rttMs) {
    if (!Number.isFinite(rttMs)) {
        return "No RTT data";
    }
    if (rttMs < 60) {
        return "Healthy RTT";
    }
    if (rttMs < 120) {
        return "Watch RTT";
    }
    return "Needs attention";
}

export function formatMedianRtt(rttMs, digits = 0) {
    if (!Number.isFinite(rttMs)) {
        return "No RTT data";
    }
    return `${rttMs.toFixed(digits)} ms median RTT`;
}

export function formatTrafficVolume(bytes, digits = 2) {
    const value = finiteNumber(bytes) ?? 0;
    return `${scaleNumber(value, digits)}B`;
}
